var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30396 13.6277C8.17646 13.6277 8.05646 13.6052 7.92896 13.5602C7.51646 13.4027 7.24646 13.0202 7.24646 12.5777V10.1027H6.51146C6.09146 10.1027 5.72396 9.86271 5.55146 9.48771C5.37896 9.10521 5.44646 8.67771 5.72396 8.36271L8.91896 4.73271C9.21146 4.40271 9.66146 4.29021 10.074 4.44771C10.4865 4.60521 10.7565 4.98771 10.7565 5.43021V7.90521H11.499C11.919 7.90521 12.2865 8.14521 12.459 8.52021C12.6315 8.90271 12.564 9.33021 12.2865 9.64521L9.09146 13.2752C8.88146 13.5002 8.59646 13.6277 8.30396 13.6277ZM6.67646 8.97771H7.80896C8.11646 8.97771 8.37146 9.23271 8.37146 9.54021V12.3752L11.3265 9.02271H10.194C9.88646 9.02271 9.63146 8.76771 9.63146 8.46021V5.62521L6.67646 8.97771Z",
    fill: "url(#paint0_linear_2231_35586)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97656 17.0625C4.53656 17.0625 0.914062 13.4475 0.914062 9C0.914062 4.5525 4.53656 0.9375 8.97656 0.9375C13.4166 0.9375 17.0391 4.5525 17.0391 9C17.0391 13.4475 13.4241 17.0625 8.97656 17.0625ZM8.97656 2.0625C5.15156 2.0625 2.03906 5.175 2.03906 9C2.03906 12.825 5.15156 15.9375 8.97656 15.9375C12.8016 15.9375 15.9141 12.825 15.9141 9C15.9141 5.175 12.8016 2.0625 8.97656 2.0625Z",
    fill: "url(#paint1_linear_2231_35586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2231_35586",
    x1: 9.00521,
    y1: 4.37744,
    x2: 9.00521,
    y2: 13.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2231_35586",
    x1: 8.97656,
    y1: 0.9375,
    x2: 8.97656,
    y2: 17.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitIcon);
export default __webpack_public_path__ + "static/media/unit-icon.adefdc5f128a509ba7ad6b8da81f4a0b.svg";
export { ForwardRef as ReactComponent };